import { useSignOutMutation } from 'queries/user/useSignOutMutation'
import { useNavigate } from 'react-router'
import { useEffect } from 'react'
import { useIntercom } from 'react-use-intercom'

export function SignOutPage() {
  const navigate = useNavigate()
  const { hardShutdown: shutdownIntercom } = useIntercom()
  const { mutate: signOut } = useSignOutMutation({
    onSuccess: () => {
      shutdownIntercom()
      navigate('/login', { replace: true })
    },
  })

  useEffect(signOut, [])

  return null
}
